<!-- @file 移动竖屏端签到组件 -->

<template>
  <div class="plv-check-in-portrait" :style="{ '--fullRate': fullRate } "  :class="{'plv-iar-default-portrait-check-in--fullscreen': isFullScreen}">
    <div class="plv-check-in-portrait__modal" :class="{'plv-check-in-portrait__modal--force-check-in': forceCheckInEnabled && !isShowList && !isShowResult}">
      <check-in-list v-if="isShowList" :list="list"/>
      <template  v-else>
        <template v-if="isShowResult">
          <div class="plv-iar-check-in-default__success-bg">
            <img src="./imgs/check-in-success-bg.png" alt="" />
            <span>{{ iarTrans('checkIn.checkInSuccess')}}</span>
            <div style="width: 100%;">
              <div class="plv-iar-check-in-default__btn__wrap__mobile">
                <iar-button v-if="oldCheckInSocket"
                            class="plv-check-in-default__btn--record"
                            type="cancel"
                            @click="$emit('to-hide')">{{ iarTrans('checkIn.close') }}</iar-button>
                <iar-button v-else
                            class="plv-check-in-default__btn--record"
                            type="cancel"
                            @click="getCheckInInfo">{{ iarTrans('checkIn.record') }}</iar-button>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="plv-check-in-portrait__modal__content">
          <p class="plv-check-in-message" :class="{'plv-check-in-message--force-check-in': forceCheckInEnabled}"><span>{{ message }}</span></p>
          <div class="plv-iar-portrait-check-in__content__time">
            <span>{{ $t('checkIn.checkInTimeTip') }}</span>
            <countdown :duration="leftTime" size="small" />
          </div>
          <p v-if="forceCheckInEnabled" class="plv-check-in-default__content-tip">{{ iarTrans('checkIn.checkInTip') }}</p>
          <div style="width: 100%;">
            <div class="plv-iar-check-in-portrait__btn__wrap__mobile">
              <iar-button
                class="plv-check-in-default__btn--confirm"
                :btn-style="btnStyle"
                :disabled="disabled"
                @click="signIn"> {{ iarTrans('checkIn.checkInBtn') }}</iar-button>
            </div>
          </div>
        </div>
      </template>
      <div class="plv-check-in-portrait__modal__close" @click="close"></div>
    </div>
  </div>
</template>

<script>
import IarButton from '../../components/common/button/MobileButton';
import CheckInList from '../../components/check-in/check-in-list/checkInList';
import Countdown from '../../components/check-in/countdown/countdown.vue';
import mixin from './mixin';
import fullscreen from '../../assets/mixins/fullscreen';

export default {
  props: {
    // 网页全屏， 需要旋转90度适配
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CheckInList,
    IarButton,
    Countdown,
  },
  mixins: [mixin, fullscreen],
  created() {
    this.preLoadBg();
  },
  methods: {
    preLoadBg() {
      const checkInBgImg = new Image();
      const checkInSuccessImg = new Image();
      checkInBgImg.src = require('./imgs/check-in-bg.png');
      checkInSuccessImg.src = require('./imgs/check-in-success.png');
    },
    close() {
      this.$emit('to-hide');
      this.clear();
    }
  }
};
</script>

<style lang="scss">
.plv-check-in-portrait {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
  .plv-check-in-portrait__modal {
    width: 300px;
    height: 300px;
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -40%);
    background-image: url('./imgs/check-in-bg.png');
    background-size: 100% 100%;
    background-position: center;
    .plv-iar-check-in-default__btn__wrap__mobile {
      padding: 0 24px;
    }
    .plv-iar-checkIn-list--mobile {
      padding-top: 8px;
    }
    .plv-iar-checkIn-list::-webkit-scrollbar-track {
      background-color: inherit;
    }
    .plv-iar-checkIn-list {
      max-height: 170px;
      margin-top: 100px;
      .plv-ia-c-table-wrapper-table-thead {
        display: none;
      }
      .plv-ia-c-table-wrapper .plv-ia-c-table-wrapper-table-tbody-tr:nth-child(2n) {
        background: linear-gradient(98deg, rgb(255 163 17 / 5%) -6%, rgb(255 190 47 / 5%) 100%);
      }
    }
    &__content {
      width: 100%;
      margin-top: 94px;
      text-align: center;
    }
    >p {
      margin: 0;
    }

    &__close {
      background-image: url('./imgs/check-in-close.png');
      background-size: contain;
      position: absolute;
      bottom: -66px;
      left: 50%;
      transform: translateX(-50%);
      width: 32px;
      height: 66px;
    }
    .plv-check-in-default__btn--confirm:active {
      background-color: inherit;
      color: inherit;
    }
  }
  .plv-check-in-portrait__modal--force-check-in {
    height: 370px;
  }
  .plv-check-in-message {
    line-height: normal;
    box-sizing: border-box;
    font-size: 16px;
    margin: 0;
    padding: 24px 24px 0 24px;
    min-height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-all;
    font-weight: 500;
    color: #333333;
    span {
      display: -webkit-box;
      line-clamp: 3;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
    }
  }
  .plv-check-in-message--force-check-in {
    min-height: 66px;
    padding-top: 46px;
    margin-bottom: 12px;
  }
  .plv-iar-portrait-check-in__content__time {
    font-size: 12px;
    color: #666;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  .plv-check-in-default__content-tip {
    font-size: 14px;
    color: #606266;
    margin-top: 8px;
    padding: 0 32px;
    line-height: 24px;
  }
  .plv-check-in-time {
    font-size: 12px;
    color: #666;
    margin: 16px 0 24px;
    >span {
      color: #FFC038;
    }
  }
  .plv-iar-check-in-portrait__btn__wrap__mobile {
    margin: 0 auto;
    width: 208px;
    height: 36px;
    text-align: center;
  }
  .plv-iar-check-in-default__success-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 110px;
    img {
      width: 96px;
      height: 96px;
      margin-bottom: 10px;
    }
    .plv-iar-check-in-portrait__btn__wrap__mobile {
      padding: 0 24px;
    }
    .plv-check-in-default__btn--record {
      border: 1px solid #FFA611;
      color: #FFA611;
      margin-right: 0;
      height: 36px;
      line-height: 36px;
      padding: 0;
      margin-top: 12px;
      // background: transparent !important;
    }
  }
}
.plv-iar-default-portrait-check-in--fullscreen {
  width: 100vh;
  height: 100vw;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  .plv-check-in-portrait__modal__close {
    position: absolute;
    top: 40px !important;
    left: unset !important;
    right: -55px;
    height: 32px !important;
    background-image: url(./imgs/btn-close-3.png) !important;
  }
}
@media screen and (min-aspect-ratio: 4/3) {
  .plv-check-in-portrait__modal {
    // 按屏幕高度比例进行缩放80%
    transform: translate(-50%, -50%) scale(var(--fullRate));
  }
  .plv-check-in-portrait__modal__close {
    position: absolute;
    top: 40px !important;
    left: unset !important;
    right: -55px;
    height: 32px !important;
    background-image: url(./imgs/btn-close-3.png) !important;
  }
}
</style>
